jQuery(function($){
     setTimeout(function(){
      jQuery('footer').find('.footer__aside').each(function(){
        jQuery(this).find('a').each(function(){
          var curHref = String(jQuery(this).attr('href'));
          if(curHref.indexOf('shopify.com/?utm_campaign=poweredby') > -1){
            jQuery(this).html('<span class="sr-only">Shopify Link</span>');
          }
        });
      });
        jQuery('a[href]').each(function(){
          var curHtml = String(jQuery(this).html());
          var curHref = String(jQuery(this).attr('href'));
          if(curHref.indexOf('.pdf') > -1){
            if(curHtml === ''){
              jQuery(this).append('<span class="sr-only">'+curHref+'</span>');
            }
          } else {
             if(curHtml === '' || curHtml === ' '){
              jQuery(this).append('<span class="sr-only">'+curHref+'</span>');
            } else if(curHtml.indexOf('color: rgb(0, 71, 178);') > -1){
               if(String(jQuery(this).find('span').html()) === ''){
                 jQuery(this).find('span').append('<span class="sr-only">'+curHref+'</span>');
               }
            }            
          }
          if(curHref.indexOf('checkout') > -1){
            jQuery(this).attr('tabinex','0');
          }
        });
       
                
       
        
        //product list
        jQuery('.product-info__block-item').each(function(){
          jQuery(this).find('ul').each(function(){
            jQuery(this).find('li').each(function(){
              jQuery(this).removeAttr('role');
            });
          });
        });
        //scrollable regions
        jQuery('.divScroll').each(function(){
          jQuery(this).attr('tabindex','0');
        });
        //table structure
        jQuery('table.pf-inner-table').each(function(){
          jQuery(this).find('th').each(function(){
            jQuery(this).attr('scope','col');
          });
          var curRw = 0;
          var curRwCnt = '';
          jQuery(this).find('tr').each(function(){
            if(curRw === 0){
              curRwCnt = jQuery(this).html();
              
              jQuery(this).remove();
            }
            curRw++;
          });
          jQuery(this).prepend('<thead><tr>'+curRwCnt+'</tr></thead>');
        });

         //fix images
    //begin updates to alternate text, title, and aria-label if needed only
    var imgCnt = 1;
    jQuery('img').each(function () {
        var curAlt = jQuery(this).attr('alt');
        var curTitle = jQuery(this).attr('title');
        var curAriaLbl = jQuery(this).attr('aria-label');
        var curImgPrnts = jQuery(this).parents().map(function () {
            return this.tagName;
        })
            .get()
            .join(', ');

        //no alt text or empty alt text or undefined
        if (!curAlt || curAlt === '' || curAlt === 'undefined') {
            jQuery(this).attr('alt', ''); //decorative	
            if (curImgPrnts.includes('A,') || curImgPrnts.includes(' A ')) {
                jQuery(this).attr('alt', 'Image link #' + imgCnt);
                if (!curTitle || curTitle === '' || curTitle === 'undefined') {

                   } else {
                       jQuery(this).attr('title', curTitle);
                   }
                if (!curAriaLbl || curAriaLbl === '' || curAriaLbl === 'undefined') {
                    if (!curTitle || curTitle === '' || curTitle === 'undefined') {

                   } else {
                       jQuery(this).attr('aria-label', curTitle);
                   }
                } else {
                    /*add it back in*/
                    jQuery(this).attr('aria-label', curAriaLbl);
                }
            } else {
                //if empty then should not contain title or aria-label
                jQuery(this).removeAttr('aria-label');
                jQuery(this).removeAttr('title');
            }

        } else {
            //alt present so we should leave alt alone
            jQuery(this).attr('alt', curAlt);
            //if title present add an aria-label as well
            if (!curTitle || curTitle === '' || curTitle === 'undefined') {

            }
            else {
                /*Add title back in*/
                jQuery(this).attr('title', curTitle);
                //first check to make sure it doesn't already have aria-label
                if (!curAriaLbl || curAriaLbl === '' || curAriaLbl === 'undefined') {
                    jQuery(this).attr('aria-label', curTitle);
                } else {
                    /*add it back in*/
                    jQuery(this).attr('aria-label', curAriaLbl);
                }
            }

        }
        imgCnt++;
    });
    //end updates to alternate text, title, and aria-label if needed only

    

        //headings
        jQuery('.collection').parent().prepend('<h2 class="sr-only">Product Collection</h2>');
        jQuery('.collection').find('.facets-sidebar').prepend('<h3 class="sr-only">Product Filters</h3>').find('.accordion__toggle').each(function(){
          jQuery(this).attr('aria-level','4').attr('role','heading');
        });        
        jQuery('.collection').find('.collection__main').prepend('<h3 class="sr-only">Product List</h3>');
        jQuery('.featured-collections-carousel').prepend('<h3 class="sr-only">Featured Products</h3>');
        jQuery('.shopify-section--related-products').find('h2').parent().append('<h3 class="sr-only">Product List</h3>');
        jQuery('.product-card').each(function(){
          jQuery(this).find('.product-title').each(function(){
            jQuery(this).attr('aria-level','4').attr('role','heading');
          });
        });
        jQuery('.shopify-section').each(function(){
          jQuery(this).find('.section-stack').each(function(){
            //collections
            jQuery(this).find('.collection-list').each(function(){
              jQuery(this).prepend('<h2 class="sr-only">Collection Lists</h2>')
              jQuery(this).find('.collection-card').each(function(){
                jQuery(this).find('p').attr('aria-level','3').attr('role','heading');
              });
            });
            //blogs
            jQuery(this).find('.blog-post-list').each(function(){
              var cardTitle = '';
              jQuery(this).find('.blog-post-card').each(function(){
                jQuery(this).find('.blog-post-card__title').each(function(){
                  jQuery(this).attr('aria-level','3').attr('role','heading');
                  //cardTitle = String(jQuery(this).html());
                });
              });
              jQuery(this).find('.blog-post-card__read-more').each(function(){
                cardTitle = String(jQuery(this).parent().find('.blog-post-card__title').text());
                jQuery(this).append('<span class="sr-only"> - '+cardTitle+'</span>');
              });
            });
          });
        });
        jQuery('.product-info').each(function(){
          jQuery(this).find('h1').parent().append('<h2 class="sr-only">Product Information</h2>');
        });

        //footer
        jQuery('footer').prepend('<h2 class="sr-only">Footer Content</h2>').find('.h6').each(function(){
          jQuery(this).attr('role','heading').attr('aria-level','3');
        });

        jQuery('.slideshow').each(function(){
          jQuery(this).find('.h1').each(function(){
            jQuery(this).attr('role','heading').attr('aria-level','2');
          });
        });

        jQuery('.header__logo').each(function(){
          jQuery(this).find('img').attr('alt',' - Link to Home');
        });

        jQuery('a[href]').each(function(){
          var curHtml = String(jQuery(this).html());
          if(curHtml.indexOf('<img') > -1 || curHtml.indexOf('<svg') > -1){
            jQuery(this).addClass('img-link');
            if(jQuery(this).hasClass('slideshow__slide')){
              var ariaLbl = String(jQuery(this).find('img').attr('alt'));
              jQuery(this).attr('aria-label',ariaLbl);
            }
          }
        });

        //Add Aditional information for Screen readers on strike through text
        //.styles_ProductRow__price__ .styles_Price__compareAtPrice__, .styles_ProductRow__price__ .styles_Price__compareAtPrice__>span
        jQuery('.line-through').each(function(){
          jQuery(this).append('<span class="sr-only">This text is crossed out and revised.</span>');
        });
        jQuery('.styles_Price__compareAtPrice__').each(function(){
          jQuery(this).find('span').append('<span class="sr-only">This text is crossed out and revised.</span>');
        });
        var orgPrc = 0;
        jQuery('.upcart-item-compare-price').each(function(){
          jQuery(this).find('span.acsb-sr-only').each(function(){
            var curHtml = String(jQuery(this).html());
            if(curHtml.indexOf('Original Price') > -1){
              if(orgPrc > 0){
                jQuery(this).remove();
              } else {
                jQuery(this).parent().append('<span class="sr-only">This text is crossed out and revised.</span>');
              }
              orgPrc++;
            }
          });
        });

        jQuery('#sidebar-menu').attr('role','alertdialog').attr('aria-label','Mobile Navigation Menu Open');
        
        },1200); //end delay
       //cart
      setTimeout(function(){
        if(jQuery('#cart-drawer').length > 0){    
          jQuery('#cart-drawer').attr('aria-label','Shopping Cart Open').attr('role','alertdialog').attr('aria-modal','true');        
        } //end cart
      },1000);
      
      if(jQuery('quick-buy-modal').length > 0){
        jQuery('quick-buy-modal').find('button').each(function(){
          var curHtml = String(jQuery(this).html());
          if(curHtml.indexOf('Add to cart') > -1){
            jQuery(this).on('click', function(){
              //update aria-label on cart
                jQuery('#cart-drawer').attr('aria-label','Shopping Cart Open - Item Added'); 
              setTimeout(function(){
               if(jQuery('#update-notification').length > 0){}else{
                var epAlert = '<div id="update-notification" aria-live="polite" aria-atomic="true">'+
                    '<p class="ep_alertMessage">The item was added to your cart<span class="sr-only"> which is now open</span>.</p>'+
                   '</div>';
                jQuery('#cart-drawer').find('.cart-drawer__items').prepend(epAlert);
               }
              },2000);              
            });
            jQuery(this).on('keydown', function(e){
              if(e.key === 'Enter'){
                jQuery(this).click();                
              }
            });
          }
        });
      }

      jQuery('button').each(function(){
          var curHtml = String(jQuery(this).html());
          if(curHtml.indexOf('Add to cart') > -1){
            jQuery(this).on('click', function(){
              //update aria-label on cart
                jQuery('#cart-drawer').attr('aria-label','Shopping Cart Open - Item Added'); 
              setTimeout(function(){
               if(jQuery('#update-notification').length > 0){}else{
                var epAlert = '<div id="update-notification" aria-live="polite" aria-atomic="true">'+
                    '<p class="ep_alertMessage">The item was added to your cart<span class="sr-only"> which is now open</span>.</p>'+
                   '</div>';
                jQuery('#cart-drawer').find('.cart-drawer__items').prepend(epAlert);
               }   
              },2000);              
            });
            jQuery(this).on('keydown', function(e){
              if(e.key === 'Enter'){
                jQuery(this).click();                
              }
            });
          }
        });

      //fix menu
      //adjust contents appropriately for detail/summary to work properly
      var dropdowns = 1;
      jQuery('dropdown-menu-disclosure').each(function(){
        jQuery(this).find('details').each(function(){
          jQuery(this).attr('dropCnt',dropdowns);
          dropdowns++;
        });
      });
      jQuery('dropdown-menu-disclosure').each(function(){   
        jQuery(this).find('summary').each(function(){
           //data-follow-link should be clickable but not double link - one to open detail/summary and one to target a webpage - not correct
           var curFollowLink = String(jQuery(this).attr('data-follow-link'));
           var newItem = '<a href="/collections/all" class="link-faded-reverse" data-custom-button-processed="true" >All Products</a>';
           if(curFollowLink.indexOf('#') > -1){
             jQuery(this).removeAttr('data-follow-link');
           } else {
             //test for known link
             if(curFollowLink.indexOf('/collections/all') > -1){
               jQuery(this).removeAttr('data-follow-link');
               jQuery(this).parent().find('ul').prepend('<li>'+newItem+'</li>');
             }
           }
           jQuery(this).append('<span class="icon"><svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-chevron-down" viewBox="0 0 10 10" data-acsb-hidden="true"><path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"></path></svg></span>');
        });
        //need to mark last item in each dropdown
        var listitemCnt = 0;
        var lastCnt = 0;
        jQuery(this).find('ul').each(function(){
          jQuery(this).find('li').each(function(){
            jQuery(this).attr('dropItemCount',listitemCnt);
            listitemCnt++;
          });
          lastCnt = listitemCnt;
        });
        listitemCnt = 0;
        jQuery(this).find('ul').each(function(){
          jQuery(this).find('li').each(function(){            
            listitemCnt++;
            if(lastCnt === listitemCnt){
              jQuery(this).addClass('lastItem');
            }
          });          
        });
      });
      //remove non-standard wrapper interfering with function of menu dropdown
      jQuery('dropdown-menu-disclosure').each(function(){        
        var curMenuDropdown = jQuery(this).html();
        jQuery(this).parent().append(curMenuDropdown);
        jQuery(this).remove();
      });
      //fix keyboard navigation of summary/detail to allow "enter" and "escape" keys to work properly
      jQuery('.header__primary-nav').each(function(){
        jQuery(this).find('.header__primary-nav-item').each(function(){
          //fix tooltip 
          setTimeout(function(){
          //jQuery(this).find('[data-acsb-tooltip]').attr('data-acsb-tooltip','Use [TAB] and [TAB]+[ShiftKey] to navigate. [Space] or [Enter] to open.');
            },1500);
          //each details container
          jQuery(this).find('details').each(function(){
            var curAriaExpanded = String(jQuery(this).attr('aria-expanded'));
            var curDropCnt = String(jQuery(this).attr('dropcnt'));
            //summary is button to click or enter but details should allow escape
            jQuery(this).find('summary').each(function(){
              jQuery(this).on('click', function(){
                if(curAriaExpanded.indexOf('false') > -1){
                  jQuery(this).parent().attr('aria-expanded','true');
                  jQuery(this).parent().attr('open');
                } else {
                  jQuery(this).parent().attr('aria-expanded','false');
                  jQuery(this).parent().removeAttr('open');
                }
                jQuery('.header__primary-nav').each(function(){
                  jQuery(this).find('.header__primary-nav-item').each(function(){
                    jQuery(this).find('details').each(function(){
                      var curItemCnt = String(jQuery(this).attr('dropcnt'));
                      if(curItemCnt !== curDropCnt){
                        jQuery(this).attr('aria-expanded','false');
                        jQuery(this).removeAttr('open');
                      }
                    });
                  });
                });
              });
              jQuery(this).on('keydown', function(e){
                if(e.key === 'Enter'){
                  e.preventDefault();
                  if(curAriaExpanded.indexOf('false') > -1){
                  jQuery(this).parent().attr('aria-expanded','true');
                  jQuery(this).parent().attr('open');
                } else {
                  jQuery(this).parent().attr('aria-expanded','false');
                  jQuery(this).parent().removeAttr('open');
                }
                } else if(e.key === 'Escape'){
                  e.preventDefault();
                  jQuery(this).parent().attr('aria-expanded','false');
                  jQuery(this).parent().removeAttr('open');
                }
              });              
            });
            //now deal with escape key inside details - anywhere
              jQuery(this).on('keydown',function(e){
                if(e.key === 'Escape'){
                   e.preventDefault();
                  jQuery(this).attr('aria-expanded','false');
                  jQuery(this).removeAttr('open');
                }
              });
            //finally we need to deal with the tab leaving the dropdown and going to the next item in the menu
            jQuery(this).find('.lastItem').each(function(){
              jQuery(this).on('keydown',function(e){
                if(e.key === 'Tab' && !e.shiftkey){
                   //e.preventDefault();
                  jQuery(this).parent().parent().attr('aria-expanded','false');
                  jQuery(this).parent().parent().removeAttr('open');
                }
              });
            });            
          });
        });
      });

       //update qty buttons on change
                      jQuery('.line-item-info').each(function(){
                        var curitemName = String(jQuery(this).find('.h6').text());
                        var curitemQty = '';
                        jQuery(this).find('.quantity-selector').each(function(){
                          jQuery(this).find('.quantity-selector__button').each(function(){
                            var curType = String(jQuery(this).html());
                            if(curType.indexOf('Decrease') > -1){
                              curitemQty = 'quantity change';
                            } else if(curType.indexOf('Increase') > -1){
                              curitemQty = 'quantity change';
                            }
                            //now check for action
                            jQuery(this).on('click', function(){
                              setTimeout(function(){
                                 if(jQuery('#update-notification').length > 0){
                                   jQuery('#update-notification').html('<p class="ep_alertMessage">The item '+curitemName+' had a '+curitemQty+'.</p>');
                                 }else{
                                    var epAlert = '<div id="update-notification" aria-live="polite" aria-atomic="true">'+
                                       '<p class="ep_alertMessage">The item '+curitemName+' had a '+curitemQty+'.</p>'+
                                       '</div>';
                                    jQuery('#cart-drawer').find('.cart-drawer__items').prepend(epAlert);
                                 }   
                              },2000);  
                            });
                            jQuery(this).on('keydown', function(e){
                              if(e.key === 'Enter'){
                                setTimeout(function(){
                                 if(jQuery('#update-notification').length > 0){
                                   jQuery('#update-notification').html('<p class="ep_alertMessage">The item '+curitemName+' had a '+curitemQty+'.</p>');
                                 }else{
                                    var epAlert = '<div id="update-notification" aria-live="polite" aria-atomic="true">'+
                                       '<p class="ep_alertMessage">The item '+curitemName+' had a '+curitemQty+'.</p>'+
                                       '</div>';
                                    jQuery('#cart-drawer').find('.cart-drawer__items').prepend(epAlert);
                                 }   
                              },2000);  
                              }
                            });
                          });
                        });
                      });

       setTimeout(function(){
       //Begin: handle loading/changing shopping cart popup
        if (window.shoppingCartObserver == undefined) {
            var $shoppingCartDiv = jQuery('#cart-drawer');
            if ($shoppingCartDiv.length > 0) {
                var mutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                if (mutationObserver) {
                    window.shoppingCartObserver = new mutationObserver(function (mutationList, observer) {
                      console.log('shoppingCartObserver', { mutationList: mutationList, observer: observer });
                      observer.disconnect();
                      // do ADA here.  

                      setInterval(function(){
                        //update qty buttons on change
                      jQuery('.line-item-info').each(function(){
                        var curitemName = String(jQuery(this).find('.h6').text());
                        var curitemQty = '';
                        jQuery(this).find('.quantity-selector').each(function(){
                          jQuery(this).find('.quantity-selector__button').each(function(){
                            var curType = String(jQuery(this).html());
                            if(curType.indexOf('Decrease') > -1){
                              curitemQty = 'quantity change';
                            } else if(curType.indexOf('Increase') > -1){
                              curitemQty = 'quantity change';
                            }
                            //now check for action
                            jQuery(this).on('click', function(){
                              setTimeout(function(){
                                 if(jQuery('#update-notification').length > 0){
                                   jQuery('#update-notification').html('<p class="ep_alertMessage">The item '+curitemName+' had a '+curitemQty+'.</p>');
                                 }else{
                                    var epAlert = '<div id="update-notification" aria-live="polite" aria-atomic="true">'+
                                       '<p class="ep_alertMessage">The item '+curitemName+' had a '+curitemQty+'.</p>'+
                                       '</div>';
                                    jQuery('#cart-drawer').find('.cart-drawer__items').prepend(epAlert);
                                 }   
                              },2000);  
                            });
                            jQuery(this).on('keydown', function(e){
                              if(e.key === 'Enter'){
                                setTimeout(function(){
                                 if(jQuery('#update-notification').length > 0){
                                   jQuery('#update-notification').html('<p class="ep_alertMessage">The item '+curitemName+' had a '+curitemQty+'.</p>');
                                 }else{
                                    var epAlert = '<div id="update-notification" aria-live="polite" aria-atomic="true">'+
                                       '<p class="ep_alertMessage">The item '+curitemName+' had a '+curitemQty+'.</p>'+
                                       '</div>';
                                    jQuery('#cart-drawer').find('.cart-drawer__items').prepend(epAlert);
                                 }   
                              },2000);  
                              }
                            });
                          });
                        });
                      });
                      },3000);
                      //Keyboard handler for open modal
                      //keyboardNav(config, container)  
                      /*var frogs_1;
                      var curVisibility = String($shoppingCartDiv.parent().attr('class'));
                      console.log('cart class', curVisibility);
                      if (curVisibility.indexOf('upcartPopupShow') > -1) {
                          frogs_1 = document.querySelector('#CartPopup');                         
                          keyboardNav('#CartPopup', frogs_1);
                          console.log('cart visible');
                          //set delay
                      
                      }      */               
                    });
                    window.shoppingCartObserver.observe($shoppingCartDiv[0], { attributes: false, childList: true, subtree: true });
                }
            }
        }
        //End: handle loading/changing shopping cart popup

        //deal with inappropriate Aira
      $('[aria-controls]').each(function(){
            $(this).removeAttr('aria-haspopup');
      });
      $('.prose').each(function(){
        $(this).find('ul').each(function(){
           // $(this).removeAttr('role');
           $(this).attr('role','presentation');
        });
      });

      $('img').each(function(){
        var curSrc = String($(this).attr('src'));
        if(curSrc.indexOf('https://cdn.shopify....') > -1){
            $(this).attr('alt','');//null
        }
        if(curSrc.indexOf('shiro_collection_3200x1600_1.png') > -1){
            $(this).attr('alt','');//null
        }
        if(curSrc.indexOf('win.png') > -1){
            $(this).attr('alt','Windows');//null
        }
        if(curSrc.indexOf('win_manual_1000x400_ca58debe-c771-436c-9ca5-b7caa8362527.png') > -1){
            $(this).attr('alt','Windows Manual');//null
        }
      });

      $('a[href]').each(function(){
        var curHref = String($(this).attr('href'));
        if(curHref.indexOf('type_01-multi/enus/m-it10br') > -1){
            $(this).html('<span class="sr-only">'+curHref+'</span>');
        }
        if(curHref.indexOf('MSC-DE-NEST-5000_10000_15000-0802(US_CN_KR)ver.211_231013.pdf') > -1){
            $(this).html('<span class="sr-only">'+curHref+'</span>');
        }
        if(curHref.indexOf('MSC-DE-NEST-GFL01_ALL.pdf') > -1){
            $(this).html('<span class="sr-only">'+curHref+'</span>');
        }
        if(curHref.indexOf('MSC-BM-SCLMA_SCLMP2213-0236.pdf') > -1){
            $(this).html('<span class="sr-only">'+curHref+'</span>');
        }
        
      });
      $('.jPuwGZ').each(function(){
        $(this).find('img').each(function(){
            $(this).attr('alt','');
        });
        $(this).find('a[href]').each(function(){
            var curHref = String($(this).text());
        });
      });


      }, 1500);

      
    });
    /* Keyboard Trap for Popups */
    /**
     * - Focus correct Element
     * - Trap focus,
     * - Focus the correct Element
     * @param config {
     *	el: HtmlElement. The Parent Element, within which focus should be tracked
    * }
    * @param container {
    *	querySelector for parent config
    * }
    */
    function keyboardNav(config, container) {
        if (!config) {
            throw new Error('Could not initialize focus - Config Missing');
        }
        /* Constants */
        var KEY_CODE_MAP = {
            TAB: 9,
            ENTER: 13,
            ESCAPE: 27
        };
        var FOCUSABLE_ELEMENT_SELECTORS = 'area[href], input:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="email"]:not([disabled]), input[type="tel"]:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), a[href]:not([disabled]):not(.disabled), [tabindex]';
        var el = container,
            escCallback = config.escCallback,
            focusElement = config.focusElement;
        if (!el) {
            throw new Error('Could not initialize focus - Element Missing: ' + JSON.stringify(config));
        }
        if (escCallback && !(escCallback instanceof Function)) {
            throw new Error('Could not initialize initial focus - `config.escCallback` is not a function');
        }
        var focusableElements = el.querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS);
        var keyboardHandler;

        /* Nav Menus contain focusable Elmements and possibly dropdown elements */
        if (focusableElements.length > 0) {
            var firstFocusableEl = focusableElements[0],
                lastFocusableEl = focusableElements[focusableElements.length - 1],
                elementToFocus = focusElement ? focusElement : firstFocusableEl;

            elementToFocus.focus();

            keyboardHandler = function keyboardHandler(e) {
                if (e.keyCode === KEY_CODE_MAP.ESCAPE) {
                    e.preventDefault();
                    jQuery(config).find('.upcart-header-close-button').click();
                }
                if (e.KeyCode === KEY_CODE_MAP.ENTER) {

                }
                if (e.keyCode === KEY_CODE_MAP.TAB) {
                    //Rotate Focus
                    if (e.shiftKey && document.activeElement === firstFocusableEl) {
                        e.preventDefault();
                        lastFocusableEl.focus();
                    } else if (!e.shiftKey && document.activeElement === lastFocusableEl) {
                        e.preventDefault();
                        firstFocusableEl.focus();
                    }
                }
            };/* End KeyboardHandler */
            el.addEventListener('keydown', keyboardHandler);
        }/* End focusableElements > 0 */
        //The cleanup function. Put future cleanup tasks inside this.
        return function cleanUp() {
            if (keyboardHandler) {
                el.removeEventListener('keydown', keyboardHandler);
            }
        }; /* End Cleanup */
    }/* End function*/